module.exports = __webpack_public_path__ + "static/img/login_bg.ae2768ed.png";